import * as types from '../constants/actionTypes';

const programIndicators = (state = {}, action) => {
    switch (action.type) {
        case types.PROGRAM_INDICATORS_SET:
            return {
                ...state,
                [action.programId]: action.payload,
            };

        default:
            return state;
    }
};

export default programIndicators;



// WEBPACK FOOTER //
// ./src/reducers/programIndicators.js